import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import villageReducer from '../slices/villageSlice';
const store = configureStore({
  reducer: {
    auth: authReducer,
    village: villageReducer,
  },
});

export default store;
